module.exports = __webpack_public_path__ + "img/home_auth3.11309f09.png";